import z from 'zod';

const ApplicationTypeSchema = z.enum([
  'chat',
  'composite',
  'composite_e1',
  'composite_e2',
  'llm_pass_through',
]);

export const ApplicationSchema = z.object({
  applicationType: ApplicationTypeSchema.nullable(),
  description: z.string(),
  displayName: z.string(),
  id: z.string(),
  initialMessage: z.string().nullable(),
  name: z.string(),
});
